import { render, staticRenderFns } from "./RankingRow.vue?vue&type=template&id=1fab1eeb&scoped=true"
import script from "./RankingRow.vue?vue&type=script&lang=js"
export * from "./RankingRow.vue?vue&type=script&lang=js"
import style0 from "./RankingRow.vue?vue&type=style&index=0&id=1fab1eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab1eeb",
  null
  
)

export default component.exports